
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, of } from "rxjs";
import { switchMap, shareReplay } from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})

export class AdminService {

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json" }) };

  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
    ) {
      this.firestore.firestore.settings({experimentalForceLongPolling: true});
    }

  //HttpMethods

  // get user detail 
  getUserDetailByUID(uid): Observable<any>{
    return this.firestore.collection("contacts", ref => ref.where('user_id', '==', uid)).snapshotChanges();
  }

  // getUserDetailByEmail
  getUserDetailByEmail(email): Observable<any>{
    return this.firestore.collection("contacts", ref => ref.where('email', '==', email)).snapshotChanges();
  }

  //create user
  createUser(data): Observable<any> {
    return this.http.post("create_user", data, this.noAuthHeader);
  }

  // import rs2 user
  importRs2User(id, data=null): Observable<any> { // update_date_time 
    return this.http.post("import_rs2_user", data, this.noAuthHeader);
  }

  // getAllProjects...
  getAllProjects(limit): Observable<any> { // 7,000 records 'date_created','asc' | 9,000 'date_created','desc'
    return this.firestore.collection("projects", ref => ref.orderBy('date_created','asc').limit(limit)).get(); 
    // return this.firestore.collection("rs2_nodes", ref => ref.where('type',"==",'client')).snapshotChanges(); 422614677 205100010
  }

  getProjectsByUid(uid): Observable<any> {
     return this.firestore.collection("projects", ref => ref.where('owner_user_id','==',uid)).get(); 
    // return this.firestore.collection("rs2_nodes", ref => ref.where('type',"==",'client')).snapshotChanges(); 422614677 205100010
    // return this.firestore.collection("rs2_nodes", ref => ref.where('field_project_nid.und','array-contains',{"format":null,"safe_value":"422634910","value":"422634910"})).snapshotChanges(); 

  }


  importRS2DriveFile(form): Observable<any>{
    return this.http.post("import_rs2_drive_file", form, this.noAuthHeader); 
    // return this.http.get("count_contacts", this.noAuthHeader); 
  }

  // Check files in rs2_nodes
  // checkProjectInNode(project_id):Observable<any>{
  //   return this.firestore.collection("rs2_nodes",ref=> ref.where("type","==","google_drive_content").where("field_project_nid.und","array-contains",{"value":project_id.toString(),"safe_value":project_id.toString(),"format":null}).get();
  // }

  // create lead createLead
  // createLead(data): Observable<any> { 
  //   return this.http.post("create_lead", data, this.noAuthHeader);
  // }
  editUser(form,uid) {
    return this.firestore.collection("contacts").doc(uid).update(form);
  }

  editUser1(form,uid) {
    return this.firestore.collection("users").doc(uid).update(form);
  }


  // edit contact type
  editContactType(form,uid) {
    return this.firestore.collection("contact_types").doc(uid).update(form);
  }

  // edit contact source
  editContactSource(form,uid) {
    return this.firestore.collection("contact_sources").doc(uid).update(form);
  }

  // edit comment type
  editCommentType(form,uid) {
    return this.firestore.collection("comment_types").doc(uid).update(form);
  }
  

  // delete contact type
  deleteContactType(uid) {
    return this.firestore.collection("contact_types").doc(uid).delete();
  }

  // delete contact source
  deleteContactSource(uid) {
    return this.firestore.collection("contact_sources").doc(uid).delete();
  }

  // delete comment type
  deleteCommentType(uid) {
    return this.firestore.collection("comment_types").doc(uid).delete();
  }
  

  // edit job function
  editJobFunction(form,uid) {
    return this.firestore.collection("job_functions").doc(uid).update(form);
  }
  
  // delete job function
  deleteJobFunction(uid) {
    return this.firestore.collection("job_functions").doc(uid).delete();
  }

  // edit project
  editProject(form,id) {
    return this.firestore.collection("projects").doc(id).update(form);
  }


  //delete project
  deleteProject(uid) {
    return this.firestore.collection("projects").doc(uid).delete();
  }

  // createContactType
  createContactType(data): Observable<any> {
    return this.http.post("create_contact_type", data, this.noAuthHeader);
  }
  // get contact type list...
  getContactTypeList(): Observable<any> {
    // return this.http.get("get_user_list?uid="+uid, this.noAuthHeader);
    return this.firestore.collection("contact_types").snapshotChanges();
  }

  // get list for contacts main menu
  getContactMenuList(): Observable<any> {
    // return this.http.get("get_user_list?uid="+uid, this.noAuthHeader);
    return this.firestore.collection("contact_types", ref => ref.where('in_contacts_main_menu', '==', 'yes')).snapshotChanges();
  }

  // get user list
  getUserList(uid): Observable<any> {
    // return this.http.get("get_user_list?uid="+uid, this.noAuthHeader); , ref => ref.where('record_type', '==', 'user')
    return this.firestore.collection("users", ref => ref.orderBy('first_name','asc')).snapshotChanges(); //, ref=> ref.limit(100)
  }

  checkDriveUpload(): Observable<any>{
    return this.http.get("drive_file_upload", this.noAuthHeader);
  }

  // getLeadList() { 
  //   return this.firestore.collection("contacts", ref => ref.where('record_type', '==', 'lead')).snapshotChanges();
  // }

  // addEvent(data) { 
  //   return this.http.post("add_event", data, this.noAuthHeader);
  // }

  getEventList(uid) { 
    return this.firestore.collection("calendar_events", ref => ref.where('author_user_id', '==', uid)).snapshotChanges();
  }

  addFile(data) { 
    return this.http.post("add_file", data, this.noAuthHeader);
  }

  addShowroom(form) {
  const showroomId = (form.id && form.id!=="") ?   form.id : this.firestore.createId();
  form.id = showroomId;
    return this.firestore.collection("showrooms").doc(showroomId).set(form);
  }

  geShowroomList() { 
    return this.firestore.collection("showrooms", ref => ref.orderBy('name','asc')).snapshotChanges();
  }

  getSuggestions(queryString){
    return this.http.get("get_location?query_string="+queryString, this.noAuthHeader).pipe(shareReplay(1));
    // 
    // .pipe(switchMap((res: any) => {
    //   return of(res);
    // }));
  }
 
  getUserDetail(uid) { 
    return this.firestore.collection("contacts").doc(uid).snapshotChanges();
  }

  getContactTypeDetail(uid) { 
    return this.firestore.collection("contact_types").doc(uid).snapshotChanges();
  }

  // get contact source detail
  getContactSourceDetail(uid) { 
    return this.firestore.collection("contact_sources").doc(uid).snapshotChanges();
  }

  // get comment type detail
  getCommentTypeDetail(uid) { 
    return this.firestore.collection("comment_types").doc(uid).snapshotChanges();
  }
  

  // get job function detail
  getJobFunctionDetail(uid) {
    return this.firestore.collection("job_functions").doc(uid).snapshotChanges();
  }

  // get project detail...
  getProjectDetail(uid){
    return this.firestore.collection("projects").doc(uid).snapshotChanges();
  }


  // create contact source
  createContactSource(data): Observable<any> {
    return this.http.post("create_contact_source", data, this.noAuthHeader);
  }
  
  // get contact source list
  getContactSourceList(): Observable<any> {
    return this.firestore.collection("contact_sources", ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  // get comment types list
  getCommentTypeList(): Observable<any> {
    return this.firestore.collection("comment_types", ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }
  

  // create job function
  createJobFunction(data): Observable<any> {
    return this.http.post("create_job_function", data, this.noAuthHeader);
  }

   // get job function list
  getJobFunctionList(): Observable<any> {
    return this.firestore.collection("job_functions").snapshotChanges();
  }
  // Get Record count
  getTotalCount(): Observable<any> {
    //  return this.firestore.collection("calendar_events", ref => ref.where("owner_user_id","==","13638")).get();
    // return this.firestore.collection("rs2_nodes", ref => ref.where("type","==","calendar_events").where("uid","==","13638")).get(); //google_drive_content
    return this.firestore.collection("contacts").get();
  }

  // created_date_year task
  // getAllContacts
  getAllContacts(lastInResponse=null):Observable<any>{
    if(lastInResponse){
      return this.firestore.collection("contacts", ref => ref.orderBy('date_created','desc').startAfter(lastInResponse).limit(500)).get();
    } else {
      return this.firestore.collection("contacts", ref => ref.orderBy('date_created','desc').limit(500)).get();
    }
  }

  // Delete Batchwise

  deleteBatchWise(id){
    var batch = this.firestore.firestore.batch();
    //  contacts projects calendar_events owner_user_id
    //  rs2_nodes uid
   const obsr = this.firestore.collection('calendar_events', ref => ref.where('owner_user_d','==',"13638").limit(500)).get();
   return obsr.toPromise().then(function(querySnapshot) {
        // Once we get the results, begin a batch
        
        querySnapshot.forEach(function(doc) {
            // For each doc, add a delete operation to the batch
            batch.delete(doc.ref);
        });

        // Commit the batch
        return batch.commit();
  }).then(function() {
      // Delete completed!
      console.log('Records deleted!');
  }); 
  }

  // createWebsite
  /*addNewWebsite(data): Observable<any> {
    return this.http.post("add_new_website", data, this.noAuthHeader);
  }*/

  addWebsite(form) {
    
    const websiteId = this.firestore.createId();
    form.id = websiteId;
      return this.firestore.collection("websites").doc(websiteId).set(form);
    }

  // get website list
  getWebsiteList(): Observable<any> {
    return this.firestore.collection("websites").snapshotChanges();
    // return this.firestore.collection('rs2_nodes', ref => ref.where("type","==","google_drive_content")).get();
    // return this.firestore.collection('projects').get(); //Contacts: 14544 // Users 237 // Projects 14769
  }

  // Create Project Status 
  createProjectStatus(data): Observable<any> {
    return this.http.post("create_project_status", data, this.noAuthHeader);
  }

  // Make dummy http call
  create_marketing_list_entry(data): Observable<any> {
    return this.http.post("create_marketing_list_entry_http", data, this.noAuthHeader);
  }


  // get project status list
  getProjectStatusList(): Observable<any> {
    return this.firestore.collection("project_status").snapshotChanges();
  }

  // code to delete project status
  deleteProjectStatus(uid) {
    return this.firestore.collection("project_status").doc(uid).delete();
  }

  // get project status detail...
  getProjectStatusDetail(uid) {
    return this.firestore.collection("project_status").doc(uid).snapshotChanges();
  }

  //edit project status
  editProjectStatus(form,uid) {
    return this.firestore.collection("project_status").doc(uid).update(form);
  }

  // Code to delete 
  deleteWebsite(uid) {
    return this.firestore.collection("websites").doc(uid).delete();
  }

  // get website detail
  getWebsiteDetail(uid) {
    return this.firestore.collection("websites").doc(uid).snapshotChanges();
  }

  //edit website
  editWebsite(form,uid) {
    return this.firestore.collection("websites").doc(uid).update(form);
  }

  // create project map step
  createProjectMapStep(data): Observable<any> {
    return this.http.post("create_project_map_step", data, this.noAuthHeader);
  }

  // get project map step list
  getProjectMapList(): Observable<any> {
    return this.firestore.collection("project_map_steps", ref => ref.orderBy('number')).snapshotChanges();
  }

  // Get email settings data...
  getEmailSettings(): Observable<any> {
    return this.firestore.collection("email_recipients").snapshotChanges();
  }

  // create project map field
  createProjectMapField(data): Observable<any> {
    return this.http.post("create_project_map_field", data, this.noAuthHeader);
  }
  // Code to get the list of field of selected field
  getProjectMapFieldList(project_map_step_id) { 
    let arr = [];
    arr.push(project_map_step_id);
    if(project_map_step_id==="axHCZ2T6Gdkp1H6XjPRh" || project_map_step_id==="evwdciVNp0SQ6Qwxd7xy"){ // Extra condition to show the Pre-delivery Checklist Field in two different steps
      arr.push('evwdciVNp0SQ6Qwxd790');
    }
    return this.firestore.collection("project_map_fields", ref => ref.where('project_map_step_id', 'in', arr)).snapshotChanges();
  }
  // delete project map step...
  deleteProjectMapStep(uid) {
    return this.firestore.collection("project_map_steps").doc(uid).delete();
  }

  //Get email  recipients by id
  getEmailRecipient(id){
    return this.firestore.collection("email_recipients").doc(id).snapshotChanges();
  }

  // delete email recipients
  deleteEmailRecipients(uid) {
    return this.firestore.collection("email_recipients").doc(uid).delete();
  }


  // delete project map field
  deleteProjectMapField(step_id) {
    return this.http.delete("delete_project_map_fields?step_id="+step_id, this.noAuthHeader);
  }
  
  // delete project map field by id
  deleteProjectMapFieldById(uid) {
    // return this.http.delete("delete_project_map_fields?step_id="+step_id, this.noAuthHeader);
    return this.firestore.collection("project_map_fields").doc(uid).delete();
  }

  // get porject map step detail
  getProjectMapStepDetail(id) {
    return this.firestore.collection("project_map_steps").doc(id).snapshotChanges();
  }

  // edit project map step
  editProjectMapStep(form,id) {
    return this.firestore.collection("project_map_steps").doc(id).update(form);
  }

  // Create Email Settings...
  createEmailRecipients(form) {
    return this.firestore.collection("email_recipients").doc(form.id).set(form);
  }

  // Update Email Settings
  updateEmailRecipients(form,id) {
    return this.firestore.collection("email_recipients").doc(id).update(form);
  }

  //edit project map field
  editProjectMapStepField(form,id) {
    return this.firestore.collection("project_map_fields").doc(id).update(form);
  }

  // create permission
  createPermission(data): Observable<any> {
    return this.http.post("create_permission", data, this.noAuthHeader);
  }
  // get permission details
  getPermissionList() {
    return this.firestore.collection("user_permissions").snapshotChanges();
  }


  // delete permission
  deletePermission(uid) {
    return this.firestore.collection("user_permissions").doc(uid).delete();
  }

  // get permission detail
  getPermissionDetail(uid) {
    return this.firestore.collection("user_permissions").doc(uid).snapshotChanges();
  }
  // edit permission
  editPermission(form,uid) {
    return this.firestore.collection("user_permissions").doc(uid).update(form);
  }

  // clear database
  clearDatabase(data): Observable<any> {
    return this.http.post("clear_database", data, this.noAuthHeader);
  }

  // get showroom detail
  getShowroomDetail(id) {
    return this.firestore.collection("showrooms").doc(id).snapshotChanges();
  }

  // edit showroom...
  editShowroom(form,uid){
    return this.firestore.collection("showrooms").doc(uid).update(form);

  }

  // get system urls
  geSystemUrls(): Observable<any> {
    return this.firestore.collection("system").snapshotChanges();
  }

  // update system url...
  updateSystemUrl(form,id) {
    return this.firestore.collection("system").doc(id).set(form);
  }

  // createForm    
  createMarketingLists(data): Observable<any> {
    data.id = data.id ? data.id : this.firestore.createId();
    return this.http.post("create_marketing_lists", data, this.noAuthHeader);
  }

  // get form list
  getMarketingList(): Observable<any> {
    return this.firestore.collection("marketing_lists").snapshotChanges();
  }
  //get form detail
  getMarketingListDetail(id) { 
    return this.firestore.collection("marketing_lists").doc(id).snapshotChanges();
  }
  // Get Maketing list entry....
  getMarketingEntryList(): Observable<any> {
    return this.firestore.collection("marketing_list_entries").snapshotChanges();
  }


  // edit form data
  editMarketingLists(form,id) {
    return this.firestore.collection("marketing_lists").doc(id).update(form);
  }


  // delete form
  deleteMarketingLists(id) {
    return this.firestore.collection("marketing_lists").doc(id).delete();
  }

  // create project map category
  createProjectMapCategory(data): Observable<any> {
    return this.http.post("create_project_map_category", data, this.noAuthHeader);
  }
  // Code to get the list of project map cateories
  getProjectMapCatetoryList(project_map_step_id) {
    return this.firestore.collection("project_map_step_categories", ref => ref.where('project_map_step_id', '==', project_map_step_id)).snapshotChanges();
  }

  //edit project map field
  editProjectMapStepCategory(form,id) {
    return this.firestore.collection("project_map_step_categories").doc(id).update(form);
  }

  // delete project map category by id
  deleteProjectMapCategoryById(uid) {
    return this.firestore.collection("project_map_step_categories").doc(uid).delete();
  }

  // Create project map step category file
  createProjectMapCategoryFile(data): Observable<any> {
    return this.http.post("create_project_map_category_file", data, this.noAuthHeader);
  }

  // code to get the list of category file
  getProjectMapCatetoryFileList(project_map_step_category_id) {
    return this.firestore.collection("project_map_step_category_files", ref => ref.where('project_map_step_category_id', '==', project_map_step_category_id)).snapshotChanges();
  }

  // deleteProjectMapCategoryFileById
  deleteProjectMapCategoryFileById(file_id) {
    return this.firestore.collection("project_map_step_category_files").doc(file_id).delete();
  }

  // editProjectMapStepCategoryFile
  editProjectMapStepCategoryFile(form,id) {
    return this.firestore.collection("project_map_step_category_files").doc(id).update(form);
  }

  // get calender event types
  getCalenderEventTypeList(): Observable<any> {
    return this.firestore.collection("calender_event_types").snapshotChanges();
  }

  // Add calender event types 
  addCalenderEventType(data){
    return this.firestore.collection("calender_event_types").doc(data.id).set(data);
  }

  // Delete Calender Event Types 
  deleteCalenderEventTypes(id) {
    return this.firestore.collection("calender_event_types").doc(id).delete();
  }

  // Get calender event type
  getCalenderEventTypeDetail(id) {
    return this.firestore.collection("calender_event_types").doc(id).snapshotChanges();
  }

  //edit calender event types
  editCalenderEventType(form,id) {
    return this.firestore.collection("calender_event_types").doc(id).update(form);
  }
  // get client wise project list
  getClientProjectList(contactId){
    if(contactId && contactId!=undefined){
      return this.firestore.collection("projects", ref => ref.where('contact_id','==',contactId)).snapshotChanges();
    }
    else {
      return of([]);
    }
  }
  // Delete user
  // deleteUser(uid) {
  //   return this.firestore.collection("users").doc(uid).delete();
  // }

  // export data from asked collectio
  exportData(collectionName): Observable<any> {
    return this.firestore.collection(collectionName).snapshotChanges();
  }
 // Insert import data
 importData(form,collectionName) {
  // form.id = this.firestore.createId();
    return this.firestore.collection(collectionName).doc(form.id).set(form);
  }

  // RS2 User import 
  // importRs2User(uid,type=null): Observable<any> {
  //   return this.http.get(`import_rs2_data?uid=${uid}&type=${type}`, this.noAuthHeader);
  // }

  // Update Import URL
  updateImportURL(form,id): Promise<any> {
    return this.firestore.collection("import_urls").doc(id).update(form);
  }

   // get import urls
   getImportUrls(): Observable<any> {
    return this.firestore.collection("import_urls").snapshotChanges();
  }

  // Get all client
  addContactUsingRS2Import(data): Observable<any> {
    return this.http.post("add_contact_rs2_import", data, this.noAuthHeader);
  }


  checkContactTab(contact_id, user_id){
    return this.firestore.collection("user_tabs", ref => ref.where('contact_id', '==', contact_id).where('author_user_id', '==', user_id)).snapshotChanges();
  }

  createContactTab(id, form){
    return this.firestore.collection('user_tabs').doc(id).set(form);
  }

  getUserTabs(user_id){
    return this.firestore.collection("user_tabs", ref => ref.where('author_user_id', '==', user_id)).snapshotChanges();
  }

  // Delete Tab
  deleteTab(id){
    return this.firestore.collection("user_tabs").doc(id).delete();
  }

    // create comment types
    createCommentType(data): Observable<any> {
      return this.http.post("create_comment_type", data, this.noAuthHeader);
    }

    // Get accounting ref value
    async getAccoutingRef(project_id, field_id){
      // return this.firestore.collection("project_map_nodes", ref => ref.where('project_id', '==', project_id).where('project_map_field_id', '==', field_id)).snapshotChanges();
      return await new Promise(resolve => {
        this.firestore.collection("project_map_nodes", ref => ref.where('project_id', '==', project_id).where('project_map_field_id', '==', field_id))
            .snapshotChanges()
            .subscribe(
                list => {
                  resolve(list);
                });
    });
    }
  

    editProjectMapNode(form,uid) { 
    return this.firestore.collection("project_map_nodes").doc(uid).update(form);
  }

  // Get Calendar event types
  getCalendarEventTypeList(): Observable<any> {
    // return this.http.get("get_user_list?uid="+uid, this.noAuthHeader);
    return this.firestore.collection("calender_event_types").get();
  }

  // one_time_move_contact_notes
  OneTimeMovecontactNotes():Observable<any> {
    return this.http.get("one_time_move_contact_notes", this.noAuthHeader);
  }

  
  
}
